import Text from "common/Typography/Text";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import { typography } from "@shared/common/Themes/typography";
import React, { useContext } from "react";
import styled, { useTheme } from "styled-components";
import { BotBaseStrategiesContext } from "@shared/features/bots/BotForm/Strategies/BotBaseStrategiesProvider";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import { BotType } from "@shared/types";

const MaxPriceDifference = () => {
  const { maxPriceDifferenceData } = useContext(BotBaseStrategiesContext)!;
  const { botType } = useContext(BotFormContext) || {};
  const isHedgingBot = botType === BotType.HEDGING;
  const { isNewLook } = useTheme();

  if (!maxPriceDifferenceData.shouldDisplay) return null;
  // New look: grid bots show no text here, so an empty divider would be left
  // just above the form footer's own hairline.
  if (isNewLook && botType === BotType.GRID && !maxPriceDifferenceData.error)
    return null;

  return (
    <MaxDifferenceWrapper $hideDivider={isHedgingBot}>
      {botType !== BotType.GRID && !isHedgingBot && (
        <Text as="div" style={{ display: "flex", alignItems: "center" }}>
          {maxPriceDifferenceData.text}
          <HelperTooltip {...maxPriceDifferenceData.helperData} />
        </Text>
      )}
      {maxPriceDifferenceData.error && (
        <Text
          type="danger"
          style={{ marginTop: 4 }}
          $size={typography.fontSizes.S}
        >
          *{maxPriceDifferenceData.error}
        </Text>
      )}
    </MaxDifferenceWrapper>
  );
};

export default MaxPriceDifference;

const MaxDifferenceWrapper = styled.div<{ $hideDivider: boolean }>`
  border-top: ${(p) => (p.$hideDivider ? "none" : p.theme.borders.light)};
  margin-top: ${(p) => (p.$hideDivider ? 0 : 12)}px;
  padding-top: ${(p) => (p.$hideDivider ? 0 : 16)}px;
`;
